// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1nEpO","li":"CURuQ","objli":"_1WDEb CURuQ"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/Lista/Lista.scss
 ** module id = 172
 ** module chunks = 0
 **/